import { render, staticRenderFns } from "./SearchSuggestion.vue?vue&type=template&id=5ec5fcf8&scoped=true&"
import script from "./SearchSuggestion.vue?vue&type=script&lang=js&"
export * from "./SearchSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./SearchSuggestion.vue?vue&type=style&index=0&id=5ec5fcf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec5fcf8",
  null
  
)

export default component.exports